module.exports = __webpack_public_path__ + "img/diente.8b82ca66.png";